import {Box} from '@mui/material';
import React from 'react';
import {AutoCompleteItemValue} from '../../../../shared/nextgen/selector/types';
import {FormattedMessage, useIntl} from 'react-intl';

import styles from './property-filter-popup.module.scss'
import {Lx} from '../../../../../i18n/consts';
import Tag from '../../../../shared/tag';
import TagWrapper from '../../../../shared/tag-wrapper';
import {VisibleDays} from '../../../../../features/report/types';

interface Props {
    selectedEmployees: AutoCompleteItemValue[],
    selectedProjects: AutoCompleteItemValue[],
    selectedProjectTypes: AutoCompleteItemValue[],
    selectedShiftTypes: AutoCompleteItemValue[],
    selectedAbsenceTypes: AutoCompleteItemValue[],
    selectedStatuses: AutoCompleteItemValue[],
    detailedByDay?: boolean,
    visibleDays?: VisibleDays,
}

export default function FilterListPreview(props: Props){
    const intl = useIntl();
    const {
        selectedEmployees,
        selectedProjects,
        selectedProjectTypes,
        selectedShiftTypes,
        selectedAbsenceTypes,
        selectedStatuses,
        detailedByDay,
        visibleDays
    } = props;

    const visibleDaysLabel = visibleDays === VisibleDays.Incorrect
        ? intl.formatMessage({ id: Lx.Report.ONLY_INCORRECT_DAYS })
        : intl.formatMessage({ id: Lx.Report.ALL_DAYS });

    return(<Box display='flex' flexDirection='column' padding={'12px 16px'} gap={'8px'} maxWidth={300} className={styles.filtersView}>
        {
            selectedEmployees.length > 0 && <>
                <div className={styles.filtersTitle}>
                    <FormattedMessage id={Lx.General.EMPLOYEES}/>
                </div>
                <TagWrapper>
                    {selectedEmployees.map((e, key) => (
                        <Tag label={e.name} title={e.name} key={key} showCancelIcon={false}/>))}
                </TagWrapper>
            </>
        }
        {
            selectedProjects.length > 0 && <>
                <div className={styles.filtersTitle}>
                    <FormattedMessage id={Lx.General.PROJECTS} />
                </div>
                <TagWrapper>
                    {selectedProjects.map((e, key) => (
                        <Tag label={e.name} title={e.name} key={key} showCancelIcon={false}/>))}
                </TagWrapper>
            </>
        }
        {
            selectedProjectTypes.length > 0 && <>
                <div className={styles.filtersTitle}>
                    <FormattedMessage id={Lx.General.PROJECT_TYPES} />
                </div>
                <TagWrapper>
                    {selectedProjectTypes.map((e, key) => (
                        <Tag label={e.name} title={e.name} key={key} showCancelIcon={false}/>))}
                </TagWrapper>
            </>
        }
        {
            (selectedShiftTypes.length > 0 || selectedAbsenceTypes.length > 0) && <>
                <div className={styles.filtersTitle}>
                    <FormattedMessage id={Lx.General.TYPES} />
                </div>
                <TagWrapper>
                    {selectedShiftTypes.map((e, key) => (
                        <Tag label={e.name} title={e.name} key={key} showCancelIcon={false}/>))}
                    {selectedAbsenceTypes.map((e, key) => (
                        <Tag label={e.name} title={e.name} key={key} showCancelIcon={false}/>))}
                </TagWrapper>
            </>
        }
        {
            selectedStatuses && selectedStatuses.length > 0 && <>
                <div className={styles.filtersTitle}>
                    <FormattedMessage id={Lx.General.STATUS} />
                </div>
                <TagWrapper>
                    {selectedStatuses.map((e, key) => {
                        const name = intl.formatMessage({ id: e.name });
                        return (<Tag label={name} title={name} key={key} showCancelIcon={false} />)
                    })}
                </TagWrapper>
            </>
        }
        {
            detailedByDay && <>
                <div className={styles.filtersTitle}>
                    Time report
                </div>
                <TagWrapper>
                    <Tag label={'Detailed by day'} title={'Detailed by day'} showCancelIcon={false} />
                    {visibleDays !== undefined && visibleDays !== VisibleDays.All && (
                        <Tag label={visibleDaysLabel} title={visibleDaysLabel} showCancelIcon={false} />
                    )}
                </TagWrapper>
            </>
        }
    </Box>)
};
